import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const salesOrderBulkVoidAtom = createMutationAtomFactory(
  'trade.salesOrderBulkVoid',
  (params: { ids: string[]; forceUnlink?: boolean }) => ({
    tradeSalesOrderBulkVoid: {
      __args: {
        input: {
          ids: params.ids,
          forceUnlink: params.forceUnlink,
        },
      },
      results: {
        salesOrder: {
          id: true,
          documentNumber: true,
          status: true,
        },
        blockingLoads: {
          id: true,
          documentNumber: true,
          status: true,
        },
        unlinkableLoads: {
          id: true,
          documentNumber: true,
          status: true,
        },
        requiresConfirmation: true,
      },
      successCount: true,
      failedCount: true,
    },
  }),
);
